import { render, staticRenderFns } from "./tree-grid.vue?vue&type=template&id=54135502&scoped=true&"
import script from "./tree-grid.vue?vue&type=script&lang=js&"
export * from "./tree-grid.vue?vue&type=script&lang=js&"
import style0 from "./tree-grid.vue?vue&type=style&index=0&id=54135502&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54135502",
  null
  
)

export default component.exports